import ExcelJS from "exceljs";

export type ExcelHotelData = Record<string, Record<string, string>>;

/**
 * This function is used to parse an Excel file within the specified area and return every value found,
 * separated by columns. Data will be returned in a record containing the column names and another record with the cell row and value.
 * @param buffer The data buffer
 * @param startIndex The index of the top left cell. (For example, "C21")
 * @param endIndex The index of the bottom right cell.
 */
export async function importDataFromExcel(
    buffer: ArrayBuffer,
    startIndex: string,
    endIndex: string,
): Promise<ExcelHotelData | boolean> {
    const parsedData: ExcelHotelData = {};

    const workbook = new ExcelJS.Workbook();
    await workbook.xlsx.load(buffer);

    const worksheets = workbook.worksheets.filter((w) => w.state === "visible");

    if (worksheets.length == 0) return false;

    const worksheet = worksheets[0];

    const startCell = worksheet.getCell(startIndex);
    const endCell = worksheet.getCell(endIndex);

    for (let i = parseInt(startCell.col); i <= parseInt(endCell.col); i++) {
        const column = worksheet.getColumn(i);
        parsedData[column.letter] = {};
        for (let j = parseInt(startCell.row); j <= parseInt(endCell.row); j++) {
            const cell = worksheet.getCell(j, i);
            const value = cell.value;

            if (value instanceof Date) {
                parsedData[column.letter][cell.row] = value.toISOString().split("T")[0];
            } else {
                parsedData[column.letter][cell.row] = cell.value?.toString() ?? "";
            }
        }
    }

    return parsedData;
}

export async function getCellValue(buffer: ArrayBuffer, cell: string): Promise<boolean | string> {
    const workbook = new ExcelJS.Workbook();
    await workbook.xlsx.load(buffer);

    if (workbook.worksheets.length == 0) return false;

    const worksheet = workbook.worksheets[0];

    return worksheet.getCell(cell).value?.toString() ?? "";
}

export function parseExcelDate(date: string): Date | boolean {
    const dateComponents = date.split("-");

    if (dateComponents.length !== 3 || !dateComponents.every((c) => !isNaN(parseInt(c)))) {
        return false;
    }

    const startYear = parseInt(dateComponents[0]);
    const startMonth = parseInt(dateComponents[1]);
    const startDay = parseInt(dateComponents[2]);

    const newStartDate = new Date(startYear, startMonth - 1, startDay);

    if (isNaN(newStartDate.getTime())) {
        return false
    }

    return newStartDate;
}
